import { useState } from "react";
import { toast } from "sonner";
import { Play, Database } from "lucide-react";
import { api } from "@/lib/api";
import { azErr } from "@/context/AzureContext";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

const SAMPLES = [
  "Resources | project name, type, resourceGroup, location",
  "Resources | where type =~ 'microsoft.compute/virtualmachines' | project name, resourceGroup, location",
  "Resources | where type contains 'network' | project name, type",
];

export default function ResourceGraph() {
  const [query, setQuery] = useState(SAMPLES[1]);
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);

  const runQuery = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/azure/resource-graph", { query });
      setRows(data.rows);
    } catch (e) { toast.error(azErr(e)); } finally { setBusy(false); }
  };

  const cols = rows && rows.length ? Object.keys(rows[0]) : [];

  return (
    <div data-testid="az-resource-graph" className="max-w-4xl">
      <div className="flex items-center gap-2 mb-2 text-muted-foreground text-sm"><Database className="h-4 w-4 text-[#0078d4]" /> Query your resources with a small KQL subset (project, where =~ / == / contains, take).</div>
      <Textarea data-testid="az-graph-query" value={query} onChange={(e) => setQuery(e.target.value)} rows={3} className="font-mono text-sm" />
      <div className="flex items-center gap-2 mt-2 flex-wrap">
        <Button size="sm" onClick={runQuery} disabled={busy} data-testid="az-graph-run" className="bg-[#0078d4] hover:bg-[#106ebe] text-white gap-2"><Play className="h-4 w-4" /> {busy ? "Running…" : "Run query"}</Button>
        {SAMPLES.map((s, i) => <button key={i} className="text-xs text-[#0078d4] hover:underline" onClick={() => setQuery(s)}>Sample {i + 1}</button>)}
      </div>
      {rows && (
        <div className="mt-4 border border-border rounded-md overflow-hidden">
          <div className="px-3 py-2 text-xs text-muted-foreground border-b border-border">{rows.length} result(s)</div>
          <Table><TableHeader><TableRow>{cols.map((c) => <TableHead key={c}>{c}</TableHead>)}</TableRow></TableHeader>
            <TableBody>{rows.map((r, i) => (<TableRow key={i}>{cols.map((c) => <TableCell key={c} className="text-xs">{String(r[c])}</TableCell>)}</TableRow>))}
              {rows.length === 0 && <TableRow><TableCell colSpan={Math.max(1, cols.length)} className="text-center text-muted-foreground py-6">No matching resources.</TableCell></TableRow>}
            </TableBody></Table>
        </div>
      )}
    </div>
  );
}
